module.exports = __webpack_public_path__ + "img/customer.e52ceb5a.png";